import { createAsyncThunk } from "@reduxjs/toolkit";
import { ProjectManagerAxios } from "api/ProjectManagerAxios";
import { WarehouseAxios } from "api/WarehouseAxios";
import axios from "axios";

export const fetchProjectManagerTaksList = createAsyncThunk(
  "projectManager/fetchProjectManagerTaksAssignList",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any[];
  }) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());

    if (search) params.append("search", search);

    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }

    if (filters && filters.length > 0) {
      filters.forEach(({ filterField, filterValue }) => {
        if (filterField && filterValue !== undefined && filterValue !== null) {
          if (typeof filterValue === "object" && filterValue !== null) {
            Object.entries(filterValue).forEach(([key, value]) => {
              if (value !== undefined && value !== null && value !== "") {
                params.append(key, String(value));
              }
            });

            if (
              (filterValue.from_date || filterValue.to_date) &&
              (filterField === "created_at" || filterField === "updated_at")
            ) {
              const filterBy =
                filterField === "created_at" ? "created" : "updated";
              params.append("filter_by", filterBy);
            }
          } else {
            params.append(filterField, String(filterValue));
          }
        }
      });
    }

    const response = await ProjectManagerAxios.get(
      `/project-manager/task/sch_task/list/?${params.toString()}`
    );

    return {
      list: response.data.results || [],
      rowCount: response.data.total_records || 0,
    };
  }
);

export const exportProjectManagerTasksCSV = createAsyncThunk(
  "projectManager/exportProjectManagerTasksCSV",
  async (
    { search, filters }: { search?: string; filters?: any[] },
    { rejectWithValue }
  ) => {
    try {
      const params = new URLSearchParams();
      if (search) params.append("search", search);

      if (filters && filters.length > 0) {
        filters.forEach(({ filterField, filterValue }) => {
          if (
            filterField &&
            filterValue !== undefined &&
            filterValue !== null
          ) {
            params.append(filterField, String(filterValue));
          }
        });
      }

      const response = await ProjectManagerAxios.get(
        `/project-manager/task/sch_task/list/?export=csv${params.toString()}`,
        { responseType: "blob" }
      );

      const filename =
        response.headers["content-disposition"]
          ?.split("filename=")[1]
          ?.replace(/"/g, "") || "tasks.csv";

      return { blob: response.data, filename };
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to export CSV");
    }
  }
);
